const Req = window.Req;
Req.localPath = Req.localPath || '/skin/untitled/pub/';

import cfg from './config.json';

Req(
	'mobilefix', // <-- fixes rotation zoom bug in Mobile Safari, and scrolls page down to hide url bar...

	'eutils',
	'ga',
	// defaults
	'onformatchange',
	'mobilemenu',
	'query',
	'autovalidate',
	'anchortags',
	// copied from old skin
	'labelizor',
	'sharebtns',
	'imgpop 2',
	//'fickle',
	'mailtoenabler',
	//'curtain',
	'delayedhighlight',

	function() {
		'use strict';

		const $ = window.jQuery;

		// const $html = $( 'html' );

		const $win = $(window);
		// const $body = $( 'body' );
		const $doc = $(document);

		const formatMonitor = $.formatChange(
			window.FormatChange.makeGroups(cfg.mediaFormats)
		);
		const media = formatMonitor.media;

		const i18n = { en: {} };
		i18n.is = $.beget(i18n.en);
		const txt = i18n[$('html').attr('lang')] || i18n.en;

		// =========================================================================================================================
		//   Default Configs
		// =========================================================================================================================

		// =========================================================================================================================
		//   Actions
		// =========================================================================================================================

		const loggedIn = window.EPLICA_loggedin;
		const noop = $.noop;

		const tagFileAndExternalLinks = function(root) {
			i18n.en.newWindow = 'Opens in new window';
			i18n.is.newWindow = 'Opnast í nýjum vafraglugga';
			i18n.en.fileText = 'file';
			i18n.is.fileText = 'skjal';

			root.query('a:not(.videolink)').anchorTags({
				usePatterns: ['doc', 'pdf', 'xls'],
				// localDomains: ['\\.*.eplica.is','\\.*.domain.is'],
				onTag: function(link, is) {
					const text = is.pattern
						? is.pattern[0].toUpperCase() + ' ' + txt.fileText
						: is.external
						? txt.newWindow
						: '';
					text &&
						link
							.attr('target', '_blank')
							.attr(
								'title',
								$.trim(link.attr('title') || link.text()) + ' (' + text + ')'
							);

					if (link.find('img').length) {
						link.addClass('has-image');
					}

					const gaCat = is.external
						? 'external'
						: is.tel
						? 'telephone'
						: is.mailto
						? 'email'
						: is.pattern
						? 'download'
						: '';
					if (window.ga && gaCat) {
						link.on('click', function(/*e*/) {
							window.gaHXM.eventPing(
								gaCat,
								is.pattern ? 'click-' + is.pattern[0] : 'click',
								link.attr('href').replace(/^(tel|mailto):/i, ''),
								1,
								is.external ? true : false
							);
						});
					}
				},
			});
		};

		const _enhanceVideolinks = function(article) {
			article.find('a.videolink').Req('q-videolinks', function() {
				$(this).videoLinks();
			});
		};

		const _enhanceAudiolinks = !('src' in $('<audio/>')[0])
			? noop
			: function(article) {
					article.find('a.audioplayer').each(function(i, link) {
						$('<audio/>')
							.prop({
								src: link.href,
								preload: 'none',
								controls: true,
							})
							.insertBefore(link)
							.append(link);
					});
			  };

		const _openArticleImagesInModal = function(article) {
			article
				.find('p img, .imagebox img')
				// .not('.imagebox img')
				.wrap('<a class="img mini" href="#"></a>');

			article
				.find('a.mini')
				.filter('a.mini')
				.each(function() {
					const imgsrc = $(this)
						.find('img')
						.attr('src')
						.replace(/\/[^/]+\/([^/]+)$/, '/large/$1');
					$(this).attr('href', imgsrc);
				})
				.end()
				.imgPopper();
		};

		const _openArticleImageLinkInModal = function(article) {
			article
				.find('.img-pop')
				.filter('.img-pop')
				.each(function() {
					const $this = $(this);
					const $imageLinkUrl = $this.attr('href');
					const setImageLinkUrlHref = $imageLinkUrl.replace(
						/\/[^/]+\/([^/]+)$/,
						'/large/$1'
					);
				})
				.end()
				.imgPopper();
		};

		const prepArticleContent = function(root) {
			root.query('.article').each(function() {
				const article = $(this);

				if (!loggedIn) {
					_openArticleImagesInModal(article); // popup in articles
					_openArticleImageLinkInModal(article); // popup links in articles

					// article buttons
					const buttons = article.find('.buttons').last();
					if (buttons.length) {
						// window.console.log('got buttons');
						const intro = article.find('.intro');
						const englishTitle = $('.englishtitle');
						if (intro.length) {
							$('.intro').after($('.buttons'));

							if (englishTitle.length) {
								buttons
									.find('ul')
									.append(
										'<li><a class="en" href="' +
											englishTitle.find('a').attr('href') +
											'">English</a></li>'
									);
							}
							const doi = $('.doi');
							if (doi.length) {
								buttons.find('ul').prepend('<li class="doi-item"></li>');
								// We continue storing this as a link in the html (e.g. for search engines)
								// but standardize as a static text after moving (dropping any link-text)
								// The class name might be on a container or an a-element
								let url = '';
								if (doi.attr('href')) {
									url = doi.attr('href');
								} else if (doi.find('a').attr('href')) {
									url = doi.find('a').attr('href');
								}
								if (url !== '' && url.includes('doi.org/')) {
									const splitPath = url.split('doi.org/');
									$('.doi-item').prepend('doi: ' + splitPath[1]); // splitPath[1] is anything following the domain
									doi.remove();
								}
							}
						} else if (englishTitle.length) {
							buttons
								.find('ul')
								.append(
									'<li><a class="en" href="' +
										englishTitle.find('a').attr('href') +
										'">English</a></li>'
								);
							englishTitle.remove();
						}

						const canonicalUrl = $('link[rel="canonical"]').attr('href'),
							title = $.trim(
								$('title')
									.text()
									.split('|')[0]
							),
							// shareWindow,
							// sharePop = function(url) {
							// 	shareWindow = window.open(
							// 		url,
							// 		'sharepopper',
							// 		'width=626,height=436,menubar=0,status=0,titlebar=0,toolbar=0,location=0'
							// 	);
							// 	shareWindow.focus();
							// },
							sharebtns = $(
								'<ul class="social">' +
									'<li class="fb"><a href="https://www.facebook.com/sharer/sharer.php?u=' +
									encodeURIComponent(canonicalUrl) +
									'">Facebook</a></li> ' +
									'<li class="tw"><a href="https://twitter.com/intent/tweet?url=' +
									encodeURIComponent(canonicalUrl) +
									'&text=' +
									title +
									'">Twitter</a></li></ul>'
								// ).on('click', 'a', function(e) {
								// 	sharePop($(this).attr('href'));
								// 	return false;
								// }
							);

						buttons.append(sharebtns);
					}

					// Allow images in .summary to replace the main image
					//   e.g. if there are more than one author => css-hide the main .imagebox
					const summaryImgs = article.find('.summary img');
					if (summaryImgs.length) {
						article.addClass('summary-images');
					}

					// auto detect patterns,
					// then modify them to match the older/optional manually-set patterns
					article.find('td').each(function() {
						const cell = $(this);
						if (cell.find('.pmcid, .pmid, .doilink').length) {
							// at least one manually updated reference => abort
							return;
						}
						cell.html(cell.html().replace(/\s*(PMid:\d+)/gim, '<p class="pmid">$1</p>')); // strips possible whitespace before (\s)
						cell.html(
							cell.html().replace(/\s*(PMCid:PMC\d+)/gim, '<p class="pmcid">$1</p>') // strips possible whitespace before (\s)
						);
						cell.find('a[href*="doi.org"]').addClass('doilink');
					});

					// actions copied over from the previous skin
					article
						.find('.fnheader')
						.attr('id', 'fnheader')
						.end()
						.find('sup')
						.wrapInner('<a href="#fnheader"></a>');

					// doi linkur
					article
						.find('.doilink')
						.query('a') // class might be on a or p (containing a)
						.text('[CrossRef]');

					// PMid linkur
					article.find('.pmid').each(function() {
						const number = $(this)
							.text()
							.trim()
							.toLowerCase()
							.replace('pmid:', '');
						const link =
							'http://www.ncbi.nlm.nih.gov/entrez/query.fcgi?cmd=Retrieve&db=PubMed&list_uids=' +
							number +
							'&dopt=Abstract';
						$(this).html('<a href="' + link + '" target="_blank">[PubMed]</a>');
					});

					// PMCid
					article.find('.pmcid').each(function() {
						const number = $(this)
							.text()
							.trim()
							.toLowerCase()
							.replace('pmcid:', '');
						const link = 'http://www.ncbi.nlm.nih.gov/pmc/?term=' + number;
						$(this).html('<a href="' + link + '" target="_blank">[PMC]</a>');
					});

					article
						.find('.doilink, .pmid, .pmcid')
						.next('br')
						.remove();
					// end actions-copied-over

					// look for a (manually inserted) soundcloud link
					article.find('a.soundcloud').each(function() {
						const soundLink = $(this).attr('href');
						$(
							'<li class="sc"><a href="' + soundLink + '">Hlusta hjá Soundcloud</a></li>'
						).appendTo($('ul.social'));
						$(this).remove(); // is hidden by CSS as well
					});

					// look for a (manually inserted) Spotify link
					article.find('a.spotify').each(function() {
						const spotifyLink = $(this).attr('href');
						$(
							'<li class="sp"><a href="' + spotifyLink + '">Hlusta hjá Spotify</a></li>'
						).appendTo($('ul.social'));
						$(this).remove(); // is hidden by CSS as well
					});

					// Tölvublöð (með/án auglýsinga)
					article.find('.issuelist a[data-doctors]').each(function() {
						const drUrl = $(this).data('doctors');
						const defaultUrl = $(this).attr('href');

						$(this).after(
							'<div class="choose">' +
								'<a href="' +
								defaultUrl +
								'" target="_blank">Almenningur</a>' +
								'<a href="' +
								drUrl +
								'" target="_blank">Fagaðilar</a>' +
								'</div>'
						);

						$(this).wrap('<span/>');
						if (window.gaHXM) {
							const nafnTolublads = $(this)
								.parent('span')
								.text()
								.trim();
							$(this)
								.parents('li')
								.find('a')
								.each(function() {
									let tegundTolublads = 'Almenningur'; // default
									if ($(this).text() === 'Fagaðilar') {
										tegundTolublads = 'Fagaðilar';
									}
									$(this)
										.addClass('listen')
										.on('click', function(e) {
											window.gaHXM.viewPing(
												$(this).attr('href'),
												'Flettirit: ' + nafnTolublads + ' ' + tegundTolublads
											);
										});
								});
						}
					});

					const issuelistUL = $('.issuelist');
					issuelistUL.delayedHighlight({
						delegate: 'li', // Set `delegate` to `null` to highlight the collection itself
						click: true, // allow clicks to set highlight on without delay
						clickToggles: true, // true makes clicks toggle the highlight on/off/on/off/etc.
						delay: 100,
					});

					$doc.on('keyup', function(e) {
						if (e.which === 27) {
							$('.issuelist li.focused').removeClass('focused');
						}
					});

					if (article.hasClass('mag')) {
						// the breadcrumbs are hidden in mobile => clone the magazine-id into the article instead
						// there is a boxhead hidden in mobile, but the breadcrumbs contain a link, which is more useful
						const issueLink = $doc.find('.breadcrumbs .current a').clone();
						$win
							.on('formatchange.breadcrumbscheck', function() {
								if (media.isSmall || media.format === 'tablet') {
									issueLink.addClass('issuelink').insertBefore(article.find('.intro'));
								}
								if (media.isLarge && media.format !== 'tablet') {
									article.find('.issuelink').remove();
								}
							})
							.trigger('formatchange.breadcrumbscheck');
					}
				} // end !loggedIn

				_enhanceVideolinks(article);
				_enhanceAudiolinks(article);
			});
		};

		const prepArticlelistContent = function(root) {
			// root.query('.article').each(function() {
			// 	const article = $(this);
			// });

			// Section articles by year
			const articlesByYear = $('.articlelist.box li');
			const articlesByYearUrl1 = articlesByYear.find('a[href^="/tolublod/"]');
			const articlesByYearUrl2 = articlesByYear.find('a[href^="/20"]');

			if (articlesByYearUrl1.length || articlesByYearUrl2.length) {
				articlesByYearUrl1.each(function() {
					const slicedUrl1 = $(this)
						.attr('href')
						.substring(10, 14);
					$(this)
						.parent()
						.addClass(slicedUrl1);
					const monthnum1 = $(this)
						.attr('href')
						.substring(15, 17);
					$(this)
						.parent()
						.attr('data-month', monthnum1);
				});
				articlesByYearUrl2.each(function() {
					const slicedUrl2 = $(this)
						.attr('href')
						.substring(1, 5);
					$(this)
						.parent()
						.addClass(slicedUrl2);

					const monthnum2 = $(this)
						.attr('href')
						.substring(6, 8);
					$(this)
						.parent()
						.attr('data-month', monthnum2);
				});
				// Get all the classes
				let uniqueClasses = [];
				$('.articlelist.box li[class^=20]').each(function() {
					const className = $(this).attr('class');
					if (uniqueClasses.indexOf(className) === -1) {
						uniqueClasses.push(className);
					}
				});
				// Filter only unique ones
				uniqueClasses = uniqueClasses.sort().reverse();
				const yearList = $('.articlelist .boxbody');
				const listClone = yearList.clone();
				yearList.empty();

				// Now group them
				$(uniqueClasses).each(function(i, v) {
					const selector = '.' + v;
					const items = listClone.find(selector);
					$('.articlelist .boxbody').append('<ul class="year ' + v + '"></ul>');
					$('.articlelist .boxbody')
						.find(selector)
						.append('<li><h3>' + v + '</h3></li>');
					$('.articlelist .boxbody')
						.find(selector)
						.append(items);
				});

				// Group by months, based on html-class ('show-months')
				$('.show-months .articlelist .boxbody ul').each(function() {
					const monthArr = [
						'',
						'janúar',
						'febrúar',
						'mars',
						'apríl',
						'maí',
						'júní',
						'júlí',
						'ágúst',
						'september',
						'október',
						'nóvember',
						'desember',
					];
					let lastMonth = '0';
					$(this)
						.find('li')
						.each(function() {
							const myMonth = $(this).attr('data-month');
							if (myMonth && myMonth !== '') {
								const monthNum = parseInt(myMonth);
								if (monthNum !== lastMonth) {
									$('<li><h4>' + monthArr[monthNum] + '</h4></li>').insertBefore($(this));
									lastMonth = monthNum; // set new reference
								}
							}
						});
				});
			}
		};

		const authorBox = function(root) {
			root.query('.articlemeta').each(function() {
				const articlemeta = $(this);
				const articlemetaH3 = articlemeta.find('h3');

				if (articlemetaH3.length < 1) {
					// hide if no authors
					articlemeta.hide();
				} else {
					if (
						articlemeta.html().includes('<br><br>') && // rough approximation using double-br as fingerprint
						articlemetaH3.text() === 'Höfundur'
					) {
						articlemetaH3.text('Höfundar');
					}
					if (media.isSmall || media.format === 'tablet') {
						// inject the metabox after .buttons
						$win
							.on('formatchange.articlemeta', function() {
								articlemeta
									.addClass('injected')
									.insertAfter(root.find('.article .buttons'));
							})
							.trigger('formatchange.articlemeta');
					}
				}
			});
		};

		// turn old-school input buttons into proper <button> elements
		const _enforceButtonElms = function(root) {
			root.find('input:submit, input:reset').each(function() {
				const inp = $(this);
				$('<button>')
					.attr({
						type: inp.attr('type'),
						name: inp.attr('name'),
					})
					.text(inp.val())
					.replaceAll(inp);
			});
		};

		const initForms = function(root) {
			$('#qstr').labelizor(); // labelize search input
			_enforceButtonElms(root);

			root.query('form').autoValidate({
				errorMsgType: 'inlineonly',
				validateEachField: 'change',
			});
		};

		const handleTelephoneLinks = function() {
			// depends on formatChange()
			i18n.is.callPrompt = 'Hringja í ';
			i18n.en.callPrompt = 'Call ';
			$doc.on('click', 'a[href^="tel:"]', function(e) {
				if (media.isLarge) {
					const m = $(this)
							.text()
							.match(/\+?\d[\s\-\d]+\d/),
						num = (m && m[0]) || this.href.substr(4);
					if (!confirm(txt.callPrompt + num + ' ?')) {
						e.preventDefault();
					}
				}
			});
		};

		// const cloneTitleIntoBanner = function(root, $image) {
		// 	// clone the magazine title into the .tible box
		// 	const magTitle = root.find('.magazine .boxhead, .magazine .subtitle').last();
		// 	// if .subtitle is found use it, else the .boxheaad
		// 	$('<small>')
		// 		.text(magTitle.text())
		// 		.prependTo($image.next('.text'));
		// };

		const imgbanner = function(root) {
			const $image = root.find('.topimg .image');
			if ($image.length) {
				$win
					.on('formatchange.imagebanner', function(/*e*/) {
						if (media.format === 'phone') {
							$image.each(function() {
								$(this).css({
									'background-image': 'url(' + $(this).attr('data-imgsmall') + ')',
								});
							});
						} else if (
							media.format === 'phablet' ||
							media.format === 'tablet' ||
							media.format === 'netbook'
						) {
							$image.each(function() {
								$(this).css({
									'background-image': 'url(' + $(this).attr('data-imgmedium') + ')',
								});
							});
						} else {
							$image.each(function() {
								$(this).css({
									'background-image': 'url(' + $(this).attr('data-imglarge') + ')',
								});
							});
						}
					})
					.trigger('formatchange.imagebanner');

				// cloneTitleIntoBanner(root, $image);
			}
		};

		// =========================================================================================================================
		//   Run Init Actions
		// =========================================================================================================================

		$doc
			.on('domupdated.main', function(e, updatedFragment) {
				const root = $(updatedFragment || this);

				// Scripts sem hafa áhrif á article content eiga ekki að keyra þegar notendur eru loggedIn vegna ritilsins.
				!loggedIn && root.query('table').wrap('<div class="tablewrap" />');
				!loggedIn &&
					root.query('ol').attr('data-oltype', function() {
						return this.type || '';
					}); // enable fancy styling on <ol> markers....

				!loggedIn && tagFileAndExternalLinks(root); // Þarf að keyrast soldið seint vegna ga tracking

				prepArticleContent(root);
				prepArticlelistContent(root);
				imgbanner(root);
				authorBox(root);
				initForms(root);
			})
			.trigger('domupdated.main');

		$.initMobileMenu({ mediaGroup: null, stickyHeader: false, resetScroll: false });
		$.initStickyHeader({
			minimal: true,
			headerHeight: () =>
				parseInt(
					window
						.getComputedStyle(document.documentElement)
						.getPropertyValue('padding-top')
				),
		}).start();
		handleTelephoneLinks(); // <- depends on formatChange

		$('html').removeClass('beforejsinit'); //remove flicker trick

		$.fixSkiplinks && $.fixSkiplinks();

		// // Loading body class scripts
		// const theme_revision = window.Req.joinUrl.split('%7C').slice(1).pop();
		// const debugSrc = document.location.search.indexOf('jsdebug') > 0 ? '-source' : '';
		// Req.loadPageScripts({ folder:'', ext: debugSrc+'.js?'+theme_revision, rootElm: document.documentElement });
	}
);
